import { render, staticRenderFns } from "./ButtonFacade.vue?vue&type=template&id=06f54226&scoped=true&"
import script from "./ButtonFacade.vue?vue&type=script&lang=js&"
export * from "./ButtonFacade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f54226",
  null
  
)

export default component.exports